/**
 * @providesModule ErrorBoundary
 *
 */

import * as React from 'react'
import styled from 'styled-components'

import { Button, Intent, NonIdealState } from '@blueprintjs/core'

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null, info: null }

  componentDidCatch (error, info) {
    this.setState({ hasError: true, error, info })

    if (typeof sentryLog === 'function') {
      sentryLog('error', 'React ErrorBoundary caught exception', {
        name: error.name,
        message: error.message,
        componentStack: info.componentStack,
      })
    }

    if (typeof Sentry !== 'undefined' && typeof Sentry.withScope === 'function') {
      Sentry.withScope(scope => {
        Object.keys(info).forEach(key => {
          scope.setExtra(key, info[key])
        })

        Sentry.captureException(error)
      })
    }
  }

  render () {
    const { hasError, error, info } = this.state
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <Container>
          <NonIdealState
            visual="error"
            title="Something went wrong"
            description={
              <>
                <Button
                  icon="comment"
                  intent={Intent.PRIMARY}
                  onClick={() => {
                    if (typeof Sentry !== 'undefined' && typeof Sentry.showReportDialog === 'function') {
                      Sentry.showReportDialog()
                    }
                  }}
                >
                  Report feedback
                </Button>
                <InfoBox error={error} info={info} />
              </>
            }
          />
        </Container>
      )
    }
    return this.props.children
  }
}
export default ErrorBoundary
const Container = styled.div.attrs({ className: 'pt-dark' })`
  margin-top: 40px;

  & .pt-non-ideal-state {
    max-width: 800px;

    & .pt-non-ideal-state-description {
      width: 100%;
    }
  }
`
class InfoBox extends React.Component {
  state = {
    detailsVisible: false,
  }
  render () {
    const { error, info } = this.props
    const { detailsVisible } = this.state
    return (
      <InfoBoxContainer>
        {detailsVisible ? (
          <InfoBoxDetails>
            <code>
              Uncaught {error?.name}: {error?.message}
              {'\n'}
              {info?.componentStack}
            </code>
          </InfoBoxDetails>
        ) : (
          <Button
            icon="info-sign"
            onClick={() => this.setState({ detailsVisible: true })}
          >
            Show Details
          </Button>
        )}
      </InfoBoxContainer>
    )
  }
}

const InfoBoxContainer = styled.div`
  margin: 16px;
`
const InfoBoxDetails = styled.pre`
  text-align: left;
  overflow-x: scroll;

  & code {
    white-space: pre;
  }
`
